/**
 * ListingDataContext — lightweight context that provides listing data
 * to NeighborhoodSpokeContent when the full Redux currentListingDetails
 * is unavailable (e.g., inside the FeedView where listings come
 * from byCoords search results rather than FetchListingWrapper).
 */
import { createContext, useContext } from 'react';

export type ListingDataOverride = Record<string, unknown>;

const ListingDataContext = createContext<ListingDataOverride | null>(null);

export const useListingDataOverride = (): ListingDataOverride | null => {
  return useContext(ListingDataContext);
};

type ListingDataProviderProps = {
  listing: object;
  children: React.ReactNode;
};

export const ListingDataProvider = ({ listing, children }: ListingDataProviderProps) => (
  <ListingDataContext.Provider value={listing as ListingDataOverride}>{children}</ListingDataContext.Provider>
);
